import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import authenticationReducer from "./features/authentication/authenticationSlice";
import { setupListeners } from "@reduxjs/toolkit/dist/query/react";
import organisationReducer from "./features/organisation/organisationSlice";
import userReducer from "./features/user/userSlice";
import inspectionReducer from "./features/inspection/inspectionSlice";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
/**
 * AirspaceLab Redux Store using Redux toolkit
 *
 * https://redux-toolkit.js.org/tutorials/typescript
 * https://redux-toolkit.js.org/usage/usage-guide
 * https://redux-toolkit.js.org/api/createAsyncThunk
 * https://redux-toolkit.js.org/usage/usage-with-typescript#type-safety-with-extrareducers
 *
 */

const rootReducer = combineReducers({
  authentication: authenticationReducer,
  organisation: organisationReducer,
  user: userReducer,
  inspection: inspectionReducer,
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["user", "organisation"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
  devTools: true,
});

export const persistor = persistStore(store);

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export default store;
